import { getRuntimeConfig } from './config';
import { getIdToken } from './auth';

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const { apiUrl } = getRuntimeConfig();
  const token = await getIdToken();

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(init.headers as Record<string, string>),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(`${apiUrl}/v1${path}`, { ...init, headers });

  if (res.status === 401) {
    const retryToken = await getIdToken();
    if (retryToken) {
      headers['Authorization'] = `Bearer ${retryToken}`;
      const retryRes = await fetch(`${apiUrl}/v1${path}`, { ...init, headers });
      if (!retryRes.ok) {
        let message = `API error ${retryRes.status}`;
        try { const b = await retryRes.json(); if (b?.error) message = b.error; } catch { /* ignore */ }
        throw new Error(message);
      }
      return retryRes.json();
    }
  }

  if (!res.ok) {
    let message = `API error ${res.status}`;
    try {
      const body = await res.json();
      if (body?.error) message = body.error;
    } catch { /* ignore parse errors */ }
    throw new Error(message);
  }
  return res.json();
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(body) }),
  put: <T>(path: string, body: unknown) =>
    request<T>(path, { method: 'PUT', body: JSON.stringify(body) }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
};
